export const API_BASE_URL = "https://api.orgchrat.iosx.in/api/v1/";
export const SOCKET_URL = "https://api.orgchrat.iosx.in";
